import { Application } from "@hotwired/stimulus"
import { registerControllers } from 'stimulus-vite-helpers'

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

const controllers = import.meta.glob(
    ['../frontend/*_controller.js', '../modal_controller.js', '../form_controller.js'],
    { eager: true }
)

registerControllers(application, controllers)

window.App = application